
{
  "familyId": "GET-KOMMA-DEEL",
  "questions": [
    {
      "id": "GET-KOMMA-DEEL-001",
      "familyId": "GET-KOMMA-DEEL",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "komma_delen",
      "questionType": "multiple_choice",
      "question": "Een bakker verdeelt 7,5 kg deeg gelijk over 3 bakvormen. Hoeveel kilogram zit er in elke vorm?",
      "options": ["2,5", "2,3", "25", "4,5"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "equalSharing",
          "data": {
            "total": 7.5,
            "parts": 3,
            "perPart": 2.5,
            "unit": "kg",
            "label": "7,5 kg verdelen over 3 bakvormen"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Delen met kommagetallen",
            "content": "Deel eerst de eenheden, dan de tienden. Schuif elke rest door naar de volgende decimaal. 7 ÷ 3 = 2 rest 1. Die rest wordt 10 tienden. 10 + 5 = 15 tienden. 15 ÷ 3 = 5 tienden. Antwoord: 2,5.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "komma_delen_heel_getal",
      "variantIndex": 1,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.75,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.komma-delen-rest-niet-doorgeschoven", "label": "Rest niet doorgeschoven (7÷3 ≈ 2,3)", "optionIndex": 1 },
          { "id": "get.komma-delen-komma-genegeerd", "label": "Komma weggelaten (75÷3 = 25)", "optionIndex": 2 },
          { "id": "get.komma-delen-aftrekken", "label": "Aftrekken i.p.v. delen", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Deel stap voor stap. Eerst de eenheden: 7 ÷ 3 = 2, rest 1. Die rest schuift door naar de tienden: 15 tienden ÷ 3 = 5 tienden. Dus 7,5 ÷ 3 = 2,5. Check: 2,5 × 3 = 7,5 ✓.",
        "solutionSteps": [
          "Deel de eenheden: 7 ÷ 3 = 2, rest 1",
          "Schuif de rest door: 1 eenheid = 10 tienden → 10 + 5 = 15 tienden",
          "Deel de tienden: 15 ÷ 3 = 5 tienden",
          "Antwoord: 2,5 kg per bakvorm",
          "Check: 2,5 × 3 = 7,5 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 7,5 ÷ 3 = 2,5. De rest van de eenheden schuift door naar de tienden.",
          "1": "Je dacht waarschijnlijk dat je eenheden en tienden apart kunt delen: 7 ÷ 3 ≈ 2,3. Maar de rest van 7 ÷ 3 moet je bij de tienden optellen: 15 tienden ÷ 3 = 5 tienden. Onthoud: de rest schuift altijd door naar de volgende plek achter de komma.",
          "2": "Je dacht waarschijnlijk dat je de komma kunt weglaten: 75 ÷ 3 = 25. Maar 7,5 is niet hetzelfde als 75 — de komma bepaalt de waarde. Onthoud: de komma blijft op dezelfde plek staan bij het delen.",
          "3": "Je dacht waarschijnlijk dat je moest aftrekken: 7,5 − 3 = 4,5. Maar de vraag is delen (÷), niet aftrekken (−). Onthoud: 'verdelen over' betekent delen."
        }
      }
    },
    {
      "id": "GET-KOMMA-DEEL-002",
      "familyId": "GET-KOMMA-DEEL",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "komma_delen",
      "questionType": "fill_in",
      "question": "Een apotheker verdeelt 12,6 ml vloeistof gelijk over 4 flesjes. Hoeveel ml zit er in elk flesje? Typ je antwoord als kommagetal.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["3,15", "3.15"],
        "caseSensitive": false,
        "placeholder": "...",
        "unit": "ml"
      },
      "stimulusAids": [
        {
          "type": "equalSharing",
          "data": {
            "total": 12.6,
            "parts": 4,
            "perPart": 3.15,
            "unit": "ml",
            "label": "12,6 ml verdelen over 4 flesjes"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Doorrekenen met rest",
            "content": "Bij 12,6 ÷ 4: de tienden geven een rest. Die rest schuif je door naar de honderdsten. 6 tienden ÷ 4 = 1, rest 2. Die 2 tienden = 20 honderdsten. 20 ÷ 4 = 5 honderdsten. Antwoord: 3,15.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "komma_delen_rest",
      "variantIndex": 2,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.74,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Deel stap voor stap met staartdeling. Eenheden: 12 ÷ 4 = 3. Tienden: 6 ÷ 4 = 1, rest 2. Die rest schuift door: 20 honderdsten ÷ 4 = 5. Dus 12,6 ÷ 4 = 3,15. Check: 3,15 × 4 = 12,6 ✓.",
        "solutionSteps": [
          "Deel de eenheden: 12 ÷ 4 = 3",
          "Deel de tienden: 6 ÷ 4 = 1, rest 2",
          "Schuif de rest door: 2 tienden = 20 honderdsten",
          "Deel de honderdsten: 20 ÷ 4 = 5",
          "Antwoord: 3,15 ml per flesje",
          "Check: 3,15 × 4 = 12,6 ✓"
        ]
      }
    },
    {
      "id": "GET-KOMMA-DEEL-003",
      "familyId": "GET-KOMMA-DEEL",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "komma_delen",
      "questionType": "fill_in",
      "question": "Een kok verdeelt 9,36 liter sap gelijk over 4 kannen. Hoeveel liter zit er in elke kan? Typ je antwoord als kommagetal.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["2,34", "2.34"],
        "caseSensitive": false,
        "placeholder": "...",
        "unit": "liter"
      },
      "stimulusAids": [
        {
          "type": "equalSharing",
          "data": {
            "total": 9.36,
            "parts": 4,
            "perPart": 2.34,
            "unit": "liter",
            "label": "9,36 liter verdelen over 4 kannen"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Stap voor stap delen",
            "content": "Deel elke plek apart: 9 ÷ 4 = 2 rest 1. Schuif door: 13 tienden ÷ 4 = 3 rest 1. Schuif door: 16 honderdsten ÷ 4 = 4. Antwoord: 2,34.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "komma_delen_context",
      "variantIndex": 3,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.73,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Deel stap voor stap. Eenheden: 9 ÷ 4 = 2, rest 1. Tienden: 13 tienden ÷ 4 = 3, rest 1. Honderdsten: 16 honderdsten ÷ 4 = 4. Dus 9,36 ÷ 4 = 2,34 liter per kan.",
        "solutionSteps": [
          "Deel de eenheden: 9 ÷ 4 = 2, rest 1",
          "Schuif de rest door: 1 eenheid + 3 tienden = 13 tienden",
          "Deel de tienden: 13 ÷ 4 = 3, rest 1",
          "Schuif de rest door: 1 tiende + 6 honderdsten = 16 honderdsten",
          "Deel de honderdsten: 16 ÷ 4 = 4",
          "Antwoord: 2,34 liter per kan"
        ]
      }
    },
    {
      "id": "GET-KOMMA-DEEL-004",
      "familyId": "GET-KOMMA-DEEL",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "komma_delen",
      "questionType": "multiple_choice",
      "question": "Een laborant meet 0,84 liter vloeistof af en verdeelt dit gelijk over 7 reageerbuisjes. Hoeveel liter zit er in elk buisje?",
      "options": ["0,12", "1,2", "0,012", "0,77"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "equalSharing",
          "data": {
            "total": 0.84,
            "parts": 7,
            "perPart": 0.12,
            "unit": "liter",
            "label": "0,84 liter verdelen over 7 reageerbuisjes"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Delen van kleine kommagetallen",
            "content": "Bij 0,84 ÷ 7: er zijn 0 eenheden. Deel de tienden: 8 ÷ 7 = 1, rest 1. Die rest wordt 14 honderdsten ÷ 7 = 2. Antwoord: 0,12. De komma blijft staan!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "komma_delen_klein_getal",
      "variantIndex": 4,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.71,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.komma-delen-komma-genegeerd", "label": "Komma weggelaten (84÷7 = 12 → 1,2)", "optionIndex": 1 },
          { "id": "get.decimal-align", "label": "Komma te ver verschoven (0,012)", "optionIndex": 2 },
          { "id": "get.komma-delen-aftrekken", "label": "Aftrekken i.p.v. delen", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Deel stap voor stap. Eenheden: 0 ÷ 7 = 0. Tienden: 8 ÷ 7 = 1, rest 1. Honderdsten: 14 ÷ 7 = 2. Dus 0,84 ÷ 7 = 0,12. Check: 0,12 × 7 = 0,84 ✓.",
        "solutionSteps": [
          "Deel de eenheden: 0 ÷ 7 = 0",
          "Deel de tienden: 8 ÷ 7 = 1, rest 1",
          "Schuif de rest door: 1 tiende + 4 honderdsten = 14 honderdsten",
          "Deel de honderdsten: 14 ÷ 7 = 2",
          "Antwoord: 0,12 liter per buisje",
          "Check: 0,12 × 7 = 0,84 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 0,84 ÷ 7 = 0,12. De komma blijft op de juiste plek staan.",
          "1": "Je dacht waarschijnlijk dat je de komma kunt weglaten: 84 ÷ 7 = 12, dus 1,2. Maar 0,84 is niet hetzelfde als 84 — de nul vóór de komma betekent dat het antwoord ook kleiner dan 1 is. Onthoud: de komma blijft op dezelfde plek bij het delen.",
          "2": "Je dacht waarschijnlijk dat er een extra nul achter de komma moet. Maar 8 tienden ÷ 7 = 1 tiende (niet 0,01). Onthoud: begin bij de tienden en werk naar rechts — de eerste rest geeft tienden, niet honderdsten.",
          "3": "Je dacht waarschijnlijk dat je moest aftrekken: 0,84 − 0,07 = 0,77. Maar de vraag is delen (÷), niet aftrekken (−). Onthoud: 'verdelen over' betekent delen."
        }
      }
    },
    {
      "id": "GET-KOMMA-DEEL-005",
      "familyId": "GET-KOMMA-DEEL",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "komma_delen",
      "questionType": "comparison_judge",
      "question": "Een timmerman zaagt een plank van 15,6 meter in 6 gelijke stukken. Welke berekening klopt?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "left": "15,6 ÷ 6",
        "right": "2,6",
        "operator": "=",
        "correctOperator": "="
      },
      "stimulusAids": [
        {
          "type": "equalSharing",
          "data": {
            "total": 15.6,
            "parts": 6,
            "perPart": 2.6,
            "unit": "meter",
            "label": "15,6 m verdelen over 6 gelijke stukken"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Delen met grote rest",
            "content": "Bij 15,6 ÷ 6: deel eerst de eenheden: 15 ÷ 6 = 2, rest 3. Die rest wordt 36 tienden. 36 ÷ 6 = 6 tienden. Antwoord: 2,6.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "komma_delen_judge",
      "variantIndex": 5,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "pedagogy": { "dok": 3 },
      "feedback": {
        "explanationText": "15,6 ÷ 6 = 2,6 (klopt). Eenheden: 15 ÷ 6 = 2 rest 3. Rest schuift door: 3 eenheden = 30 tienden + 6 tienden = 36 tienden. 36 ÷ 6 = 6. Dus 2,6. Check: 2,6 × 6 = 15,6 ✓.",
        "solutionSteps": [
          "Deel de eenheden: 15 ÷ 6 = 2, rest 3",
          "Schuif de rest door: 3 eenheden = 30 tienden + 6 tienden = 36 tienden",
          "Deel de tienden: 36 ÷ 6 = 6 tienden",
          "Antwoord: 2,6 meter per stuk klopt ✓",
          "Check: 2,6 × 6 = 15,6 ✓"
        ]
      }
    }
  ]
}
